import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

gsap.registerPlugin(ScrollTrigger);

export default function animatePostGrid(section, textLines, hr, tiles) {

  // Inidividual tweens
  // Animated lines of text
  let textLinesTween = textLines ? gsap.to(textLines, {
    duration: 0.8,
    y: 0,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Animated hr 
  let hrTween = hr ? gsap.to(hr, {
    width: "100%",
    duration: 0.4,
    opacity: 1
  }) : null;

  // Post Tiles 
  let tilesTween = tiles ? gsap.to(tiles, {
    duration: 0.8,
    scale: 1,
    opacity: 1,
    stagger: {
      each: 0.25,
      ease: "none",
      from: "start",
    },
  }) : null;

  // Timeline
  let tl = gsap.timeline({
    scrollTrigger: {
      trigger: section,
      start: "top 90%",
    },
  });

  tl
    .addLabel("textStart")
    .add(textLinesTween, "textStart-=0.4")
    .add(hrTween, "textStart")
    .add(tilesTween, "textStart+=0.4");
}